import React from 'react';
import Image from 'next/image';

const Avatar = ({name, imageurl, width = 48, height = 48}) => {
  let avatar = '';
  // If app is offline, show only names.
  if (navigator.onLine === false) {
    avatar = <div className="user-image no-image"><span>{name.charAt(0)}</span></div>;
  } else {
    if (imageurl) {
      avatar = (
        <div className="user-image">
          <Image
            src={imageurl}
            alt={`${name}`}
            width={width}
            height={height}
            loading="lazy"
            style={{ objectFit: 'cover' }}
          />
        </div>
      );
    } else {
      avatar = <div className="user-image no-image"><span>{name.charAt(0)}</span></div>;
    }
  }

  return avatar;
};

export default Avatar;